// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"IotTab_tooltip__c_vVt","icon":"IotTab_icon__2LOwf"};